import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["column"]
  static values = { updateUrl: String }

  connect() {
    this.pendingDrop = null

    this.columnTargets.forEach(column => {
      Sortable.create(column, {
        group: "prospects",
        animation: 150,
        ghostClass: "opacity-40",
        dragClass: "shadow-xl",
        onEnd: this.onDrop.bind(this),
      })
    })
  }

  onDrop(event) {
    const card = event.item
    const prospectId = card.dataset.prospectId
    const newStatus = event.to.dataset.kanbanStatus

    if (!prospectId || !newStatus || event.from === event.to) return

    if (newStatus === "declinado") {
      this.pendingDrop = event
      this.element.querySelector("#loss-reason-modal").classList.remove("hidden")
      return
    }

    this.submitStatusUpdate(prospectId, newStatus, null, event)
  }

  confirmLossReason(event) {
    const reason = event.currentTarget.dataset.reason
    const pending = this.pendingDrop
    if (!pending) return

    this.element.querySelector("#loss-reason-modal").classList.add("hidden")
    this.pendingDrop = null

    this.submitStatusUpdate(pending.item.dataset.prospectId, "declinado", reason, pending)
  }

  cancelLossReason() {
    const pending = this.pendingDrop
    if (!pending) return

    this.element.querySelector("#loss-reason-modal").classList.add("hidden")
    pending.from.insertBefore(pending.item, pending.from.children[pending.oldIndex] || null)
    this.pendingDrop = null
  }

  submitStatusUpdate(prospectId, status, lossReason, event) {
    const url = this.updateUrlValue.replace("__id__", prospectId)
    const token = document.querySelector("meta[name='csrf-token']")?.content

    const body = { status }
    if (lossReason) body.loss_reason = lossReason

    fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        "Accept": "application/json",
      },
      body: JSON.stringify(body),
    }).then(res => {
      if (!res.ok) {
        event.from.insertBefore(event.item, event.from.children[event.oldIndex] || null)
      } else {
        this.updateCounts()
      }
    }).catch(() => {
      event.from.insertBefore(event.item, event.from.children[event.oldIndex] || null)
    })
  }

  updateCounts() {
    this.columnTargets.forEach(column => {
      const status = column.dataset.kanbanStatus
      const count = column.querySelectorAll("[data-prospect-id]").length
      const badge = document.getElementById(`column-${status}-count`)
      if (badge) badge.textContent = count

      const empty = document.getElementById(`column-${status}-empty`)
      if (empty) empty.style.display = count === 0 ? "" : "none"
    })
  }
}
